import createRoute from '@widesk-ui/tools/createRoute';
import MailModel   from '@models/mail/MailModel';

export default createRoute.dashboard('/mails', 'shop', 'MailDashboard', MailModel.localize());
